import { Component, Input, OnInit } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { opacityTranslateYTrigger } from '@app/animations/opacity-translate-y.animation';
import { EventService } from '@app/services/util-services/root-services/event-service';

@Component({
  selector: 'app-b2b-popover-v1',
  templateUrl: './b2b-popover-v1.component.html',
  styleUrls: ['./b2b-popover-v1.component.scss'],
  imports: [NgClass, NgStyle],
  standalone: true,
  animations: [opacityTranslateYTrigger],
})
export class B2bPopoverV1Component implements OnInit {
  @Input() allowContentDrop = false;
  @Input() allowBackdropClose = true;
  @Input() bodyClass = 'pop-over-body';
  @Input() componentName: string;
  @Input() isDisabled: boolean;
  @Input() isToggleHeaderClick = true;
  @Input() isOpenHeaderClick = false;

  isFlyoutMenu = false;

  @Input() padding: string;
  @Input() width: string;
  @Input() left: string;
  @Input() right: string;
  @Input() top: string;
  @Input() background: string;
  @Input() border: string;
  @Input() boxShadow: string;

  constructor(private eventService: EventService) {}

  ngOnInit(): void {}

  toggleFlyoutMenu() {
    if (this.isToggleHeaderClick) {
      if (!this.isDisabled) {
        this.isFlyoutMenu = !this.isFlyoutMenu;
      }
    } else if (this.isOpenHeaderClick) {
      this.isFlyoutMenu = true;
    }

    this.callPopOverEvent();
  }

  close() {
    this.isFlyoutMenu = false;
  }

  open() {
    this.isFlyoutMenu = true;
    this.callPopOverEvent();
  }

  onBodyClick() {
    if (this.allowContentDrop) {
      this.close();
    }
  }

  onBackdrop() {
    if (this.allowBackdropClose) {
      this.close();
    }
  }

  callPopOverEvent() {
    if (this.componentName && this.isFlyoutMenu) {
      setTimeout(() => {
        this.eventService.showPopoverEvent.emit({
          componentName: this.componentName,
        });
      }, 500);
    }
  }
}
